import template from './component.tpl.html';
class FailedMessagesController {
    constructor(http, scope, env, $state) {
        this.http = http;
        this.scope = scope;
        this.env = env;
        this.state = $state;
        this.init();
        this.data = [];
        this.error = false;
        this.loading = true;
    }

    init() {
        this.initWatchers();
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.guestlistId;
        }, (newVal) => {
            this.updateData();
        });
    }

    updateData() {
        this.data = [];
        this.loading = true;
        this.error = false;

        if(_.isUndefined(this.guestlistId)) {
            this.loading = false;
            return;
        }

        this.http.post(this.env.apiUrl + '/stats/messages/latest', {
            guestlist_id: this.guestlistId,
            type: 'failed',
            count: 6
        }).then((response) => {
            this.loading = false;
            this.data = response.data.entries;
            this.applyAsync();
        }, () => {
            this.loading = false;
            this.error = true;
        });
    }

    applyAsync(){
        this.scope.$evalAsync();
    }

    goToMessage(message) {
        this.state.go('app.messages.details', {id: message.message_id});
    }
}

FailedMessagesController.$inject = [
    '$http',
    '$scope',
    'Env',
    '$state'
];

angular.module('festzelt-os.components.stats')
    .component('guestlistFailedMessagesStats', {
        bindings: {
            'guestlistId': '<'
        },
        controller: FailedMessagesController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/stats/components/guestlists/failed-messages/component.js